module.exports = __webpack_public_path__ + "static/media/alert.26c6a4c5.wav";